import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import BASEURL from '../API/Config';

const SalesReport = () => {
  const [sales, setSales] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const token = localStorage.getItem('token');

  // Fetch sales when the component is mounted
  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await fetch(`${BASEURL}/sales/list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch sales data.');

        const data = await response.json();
        setSales(data);
        setFilteredSales(data);

        if (data.length === 0) {
          Swal.fire({
            icon: 'info',
            title: 'No Sales Data',
            text: 'There are no sales records available at the moment.',
          });
        }
      } catch (error) {
        console.error(error);
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Error',
        //   text: 'Failed to load sales data.',
        // });
      }
    };

    fetchSales();
  }, [token]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Filter sales based on search query (by customer name)
    const filtered = sales.filter((sale) =>
      sale.customerName.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredSales(filtered);

    if (filtered.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Results Found',
        text: 'No sales records match your search query.',
      });
    }
  };

  const handleExportExcel = () => {
    const data = filteredSales.map((sale) => ({
      'Sale ID': sale.id,
      'Customer Name': sale.customerName,
      'Sale Date': sale.saleDate,
      'Total Amount': sale.totalAmount.toFixed(2),
      'Payment Status': sale.paymentStatus,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sales Report');

    // Export to Excel
    XLSX.writeFile(wb, 'Sales_Report.xlsx');
  };

  return (
    <div>
      <h4 className="text-center">Sales Report</h4>

      {/* Search Bar */}
      <input
        type="text"
        className="form-control mb-4"
        placeholder="Search by customer name"
        value={searchQuery}
        onChange={handleSearch}
      />

      {/* Export Excel Button */}
      <div className="d-flex justify-content-end mb-4">
        <button className="btn btn-success" onClick={handleExportExcel}>
          Export to Excel
        </button>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Sale ID</th>
            <th>Customer Name</th>
            <th>Sale Date</th>
            <th>Total Amount</th>
            <th>Payment Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredSales.length > 0 ? (
            filteredSales.map((sale) => (
              <tr key={sale.id}>
                <td>{sale.id}</td>
                <td>{sale.customerName}</td>
                <td>{sale.saleDate}</td>
                <td>{sale.totalAmount.toFixed(2)}</td>
                <td>{sale.paymentStatus}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No sales data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SalesReport;
